import React from 'react';
import { AlertCircleOutline, CloseOutline } from '@olist/design-system-icons';
import { themes } from '@olist/design-system-tokens';
import { Wrapper, Icon, Title, Description, CloseIcon } from './styles.js';
import { Flex } from '../Flex/Flex.js';

function Alert({ children, variation = 'error', closable = false, description, visible = true, showIcon = false, icon, title, onClose, }) {
    const [show, setShow] = React.useState(visible);
    function handleClose() {
        setShow(false);
        if (onClose)
            onClose();
    }
    const shouldShowAlertComponent = title || description || children;
    if (!shouldShowAlertComponent) {
        console.error('Failed prop type: title, description or children cannot be empty');
        return null;
    }
    if (!show) {
        return null;
    }
    return (React.createElement(Wrapper, { variation: variation },
        showIcon && (React.createElement(Icon, { variation: variation }, icon !== null && icon !== void 0 ? icon : React.createElement(AlertCircleOutline, null))),
        React.createElement(Flex, { flexDirection: "column", alignSelf: "center", flexGrow: 1, gap: themes.olist.base.spacing.inset['2xsmall'] },
            title && (React.createElement(Title, { variation: variation, "data-testid": "alert-title" }, title)),
            description && (React.createElement(Description, { variation: variation, "data-testid": "alert-description" }, description)),
            children),
        closable && (React.createElement(CloseIcon, { onClick: handleClose, "data-testid": "close-icon" },
            React.createElement(CloseOutline, null)))));
}

export { Alert as default };
